export default function releaseProductDirective() {
  return {
    template: require('./release-product.html'),
    restrict: 'E',
    controller: 'ReleaseProductController',
    controllerAs: 'releaseProductVM',
    bindToController: true,
    replace: true,
    scope: {
      releaseProduct: '=',
      searchText: '=',
    },
  };
}
